import React/*, {useState}*/ from 'react';
import {useracc, postApi} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
import moment from 'moment';
import { DateTime } from 'luxon';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import DJAreaSideMenu from './sidemenu';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import './css/statistics.css';

export default class DJAreaStatistics extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			djshows: {},
			djsort: 'performances',
			djperiod: 'alltime',
			guests: {},
      djstats: {},
		};
		this.DJPeriod = this.DJPeriod.bind(this);
		this.DJsort = this.DJsort.bind(this);
  };

  async componentDidMount() {
		document.title = "Admin - Mix365 Radio";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		var params = new URLSearchParams();
		params.append('djshows','1');
		params.append('djperiod','alltime');
		params.append('guests','1');
		params.append('djstats','1');
		const x = await postApi('/api/v2/djarea/statistics', params);
		this.setState({status: true, djshows: x.data.djshows, guests: x.data.guests.daily, djstats: x.data.djstats});
	}

	componentWillUnmount() {
	}

	DJPeriod(period) {
		this.setState({djperiod: period},()=>{
			this.DJsort(this.state.djsort);
		});
	}

	async DJsort(sort) {
		var params = new URLSearchParams();
		params.append('djshows','1');
		params.append('djperiod',this.state.djperiod);
		params.append('sort', sort);
		const x = await postApi('/api/v2/djarea/statistics', params);
		this.setState({djshows: x.data.djshows, djsort:sort});
	}
	

	render() {
		const djshows = 
      Object.keys(this.state.djshows).map((e,i) => {
        return (
					<Col key={i} xs={12}>
						<Row className="py-1">
							<Col className="text-vcenter" style={{width: '100px'}}>#{i+1}</Col>
							<div className="" style={{width: '70px'}}><div className="statistics-avatar"><img src={`https://mix365.co.uk${this.state.djshows[e].avatar}`} alt="Profile Avatar" /></div></div>
							<Col className="text-vcenter">{this.state.djshows[e].username}</Col>
							<Col className="text-vcenter">{this.state.djshows[e].performances}</Col>
							<Col className="text-vcenter">{this.state.djshows[e].listeners}</Col>
							<Col className="text-vcenter">{this.state.djshows[e].favorites}</Col>
							<Col className="text-vcenter">{this.state.djshows[e].likes}</Col>
							<Col className="text-vcenter">{this.state.djshows[e].hours}</Col>
						</Row>
					</Col>
				)
	    })
		const djstats = 
      Object.keys(this.state.djstats).map((e,i) => {
        return (
          <Col xs={12} key={i}>
						<Row className="py-1">
							
							<div className="" style={{width: '130px'}}><div className="statistics-stats-avatar"><img src={`https://mix365.co.uk${this.state.djstats[e].avatar}`} alt="Profile Avatar" /></div></div>
							<Col xs={4}>
								{this.state.djstats[e].djtitle?this.state.djstats[e].djtitle:'Auto DJ'}<br />

								{moment(this.state.djstats[e].start*1000).format("ddd Do MMM ~ HH:mm - ")}
								{moment(this.state.djstats[e].end*1000).format("HH:mm")}
								&nbsp;{DateTime.local().toFormat('ZZZZ')}
							
								<br />Running time: {Math.floor((this.state.djstats[e].end-this.state.djstats[e].start)/60)} minutes<br />
							</Col>
							<Col xs={3}>Max Video: {this.state.djstats[e].max_video}<br />Max Listeners: {this.state.djstats[e].max_listeners}<br />Total: {this.state.djstats[e].max_video+this.state.djstats[e].max_listeners}</Col>
							<Col>Max Guests: {this.state.djstats[e].max_guests}<br />Max Members: {this.state.djstats[e].max_members}<br /></Col>
							<Col xs={12}>
								<ResponsiveContainer width={'100%'} height={300}>
									<LineChart
										width={500}
										height={300}
										data={this.state.djstats[e].stats}
										margin={{
											top: 5,
											right: 30,
											left: 20,
											bottom: 5,
										}}
									>
										<CartesianGrid strokeDasharray="3 3" />
										<XAxis dataKey="name" />
										<YAxis />
										<Tooltip />
										<Legend />
										<Line type="monotone" dataKey="guests" stroke="#8884d8" activeDot={{ r: 8 }} />
										<Line type="monotone" dataKey="members" stroke="#82ca9d" />
										<Line type="monotone" dataKey="video" stroke="#FF8000" />
										<Line type="monotone" dataKey="listeners" stroke="#FA8072" />
									</LineChart>
								</ResponsiveContainer>
							</Col>
            	
						</Row>
          </Col>
        )
      })
		return (
			<Row className="dj-area pt-4 pb-5 px-4">
				<Col xs={12} md={2} className="djarea-sidemenu">
					<DJAreaSideMenu />
				</Col>
				<Col xs={10}>
					{this.state.status?
						<>

							<div className="card bg-dark">
								<div className="card-header">
									<h3 className="card-title">DJ Statistics</h3>
								</div>
								<div className="card-body">
									<Row>
										<Col xs={12}>
											<Button size="sm" onClick={()=>this.DJPeriod('alltime')} disabled={this.state.djperiod==='alltime'?true:false}>All Time</Button>
											<Button size="sm" onClick={()=>this.DJPeriod('month')} disabled={this.state.djperiod==='month'?true:false}>Last Month</Button>
										</Col>
										<Col xs={12}>
											<div className="row py-1">
												<div className="text-center" style={{width: '100px'}}>Rank</div>
												<div className="" style={{width: '70px'}}></div>
												<div className="col text-center"></div>
												<div className="col text-center"><span style={{cursor: 'pointer'}} onClick={()=>this.DJsort('performances')}>Performances{this.state.djsort==='performances'&&<>&nbsp;<FontAwesomeIcon icon="caret-down" style={{fontSize:14}} /></>}</span></div>
												<div className="col text-center"><span style={{cursor: 'pointer'}} onClick={()=>this.DJsort('listeners')}>Plays{this.state.djsort==='listeners'&&<>&nbsp;<FontAwesomeIcon icon="caret-down" style={{fontSize:14}} /></>}</span></div>
												<div className="col text-center"><span style={{cursor: 'pointer'}} onClick={()=>this.DJsort('favorites')}>Favorites{this.state.djsort==='favorites'&&<>&nbsp;<FontAwesomeIcon icon="caret-down" style={{fontSize:14}} /></>}</span></div>
												<div className="col text-center"><span style={{cursor: 'pointer'}} onClick={()=>this.DJsort('likes')}>Likes{this.state.djsort==='likes'&&<>&nbsp;<FontAwesomeIcon icon="caret-down" style={{fontSize:14}} /></>}</span></div>
												<div className="col text-center"><span style={{cursor: 'pointer'}} onClick={()=>this.DJsort('hours')}>Hours{this.state.djsort==='hours'&&<>&nbsp;<FontAwesomeIcon icon="caret-down" style={{fontSize:14}} /></>}</span></div>
											</div>
										</Col>

										{djshows}
									</Row>
								</div>
							</div>
					
							<div className="card bg-dark">
								<div className="card-header">
									<h3 className="card-title">Daily Visitor Counts</h3>
								</div>
								<div className="card-body">
									<ResponsiveContainer width={'100%'} height={300}>
										<LineChart
											width={500}
											height={300}
											data={this.state.guests}
											margin={{
												top: 5,
												right: 30,
												left: 20,
												bottom: 5,
											}}
										>
											<CartesianGrid strokeDasharray="3 3" />
											<XAxis dataKey="name" />
											<YAxis />
											<Tooltip />
											<Legend />
											<Line type="monotone" dataKey="count" stroke="#FA8072" activeDot={{ r: 8 }} />
										</LineChart>
									</ResponsiveContainer>
								</div>
							</div>

							<div className="card bg-dark">
								<div className="card-header">
									<h3 className="card-title">Last 15 Show Statistics</h3>
								</div>
								<div className="card-body">
									<Row>
										<Col xs={12}>
											Chart Time is UTC/GMT timezone.
										</Col>
										{djstats}
									</Row>
								</div>
							</div>
						</>
					:
						<div className="card bg-dark">
							<div className="card-header">
								<h3 className="card-title">Loading Statistics</h3>
							</div>
							<div className="card-body">
								Please wait ...
							</div>
						</div>
					}
				</Col>
			</Row>
		);
	}
}
